import { render } from "./ModalAlert.vue?vue&type=template&id=e79f49ba&scoped=true"
import script from "./ModalAlert.vue?vue&type=script&lang=js"
export * from "./ModalAlert.vue?vue&type=script&lang=js"

import "./ModalAlert.vue?vue&type=style&index=0&id=e79f49ba&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e79f49ba"]])

export default __exports__